import { graphql, Link } from "gatsby"
import React from "react"
import Img from "gatsby-image"
import Layout from "../components/layout"
import Sidebar from "../components/sidebar"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS } from "@contentful/rich-text-types"
import useContentfulImage from "../utils/useContentfulImage"
import SEO from "../components/seo"
import Relatedjirei from "../components/relatedjirei"
import Relatedsogyomae from "../components/relatedsogyomae"
import Relatedshikin from "../components/relatedshikin"
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer"
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LineShareButton,
  LineIcon,
} from 'react-share';

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: node => (
      <Img
        fluid={useContentfulImage(node.data.target.fields.file["ja-JP"].url)}
        alt={
          node.data.target.fields.description
            ? node.data.target.fields.description["ja-JP"]
            : node.data.target.fields.title["ja-JP"]
        }
      />
    ),
  },
  renderText: text => {
    return text.split("\n").reduce((children, textSegment, index) => {
      return [...children, index > 0 && <br key={index} />, textSegment]
    }, [])
  },
}

export default ( {data, pageContext, location} ) => {

  const shareUrl = location.href

  return (
  <Layout>
    <SEO 
      pagetitle={data.contentfulBlogPost.title}
      pagedesc={`${documentToPlainTextString(
        data.contentfulBlogPost.content.json)
      .slice(0, 140)}...`}
      pagepath={location.pathname}
      blogimg={`https:${data.contentfulBlogPost.eyecatch.file.url}`}
      pageimgw={data.contentfulBlogPost.eyecatch.file.details.image.width}
      pageimgh={data.contentfulBlogPost.eyecatch.file.details.image.height}
    />
    <main id="articleContainer">
      <div id="articleContent">
        <div className="article">
          <div className="articleImage">
            <figure>
              <Img 
                fluid={data.contentfulBlogPost.eyecatch.fluid}
                alt={data.contentfulBlogPost.eyecatch.description}
              />
            </figure>
          </div>

          <div className="inner">
            <div className="articleTitleHeader">
              <ul>
              {data.contentfulBlogPost.category.map(cat => (
                <li className={cat.categorySlug} key={cat.id}>{cat.category}</li>
              ))}
              </ul>
              <time datatime={data.contentfulBlogPost.publishDate}>
              {data.contentfulBlogPost.publishDateJP}
              </time>
            </div>
            <ul className="tagList">
              
              {data.contentfulBlogPost.tags && data.contentfulBlogPost.tags.map(tag => (
                <li className={tag.tagSlug} key={tag.id}><Link to={`/${tag.tagSlug}/`}>{tag.tagTitle}</Link></li>
              ))}
            </ul>
            <h1>{data.contentfulBlogPost.title}</h1>
            <div className="postbody">
              {documentToReactComponents(
                data.contentfulBlogPost.content.json,
                options
              )}
            </div>
          </div>
          {/* <div className="subscribeAlert">
            <div className="inner">
              <p>最新記事を<br />LINEで受け取ろう！</p>
              <div className="lineButton">
                  <OutboundLink href="https://lin.ee/7bvNGbd">
                      LINEで友だちに追加する
                  </OutboundLink>
              </div>
            </div>
          </div> */}
          <div className="blogShare">
            <p>記事を共有する</p>
            <div className="shareButtons">
              <LineShareButton url={shareUrl} className="mr-2">
                <LineIcon size={44} round />
              </LineShareButton>
              <TwitterShareButton url={shareUrl} className="mr-2">
                <TwitterIcon size={44} round />
              </TwitterShareButton>
              <FacebookShareButton url={shareUrl} className="mr-2">
                <FacebookIcon size={44} round />
              </FacebookShareButton>
            </div>
          </div>
        </div>
        <div id="nextPrev">
          <div className="prev">
            {pageContext.previous && (
              <Link to={`/${pageContext.previous.slug}/`} rel="next">
                <div className="nextPrevTitle">
                    <svg viewBox="0 0 263.756 41.497"><path d="M15.3-27.456A125.232,125.232,0,0,0,14.208-5.824c.32,4.1,1.216,5.632,3.136,6.656.7.384,1.024.256,1.28-.384C22.4-8.064,30.528-23.424,34.3-29.7c2.88-4.8,2.944-7.36,1.984-9.28-.384-.7-.96-.9-1.472-.128A260.966,260.966,0,0,0,18.3-8.448a211.7,211.7,0,0,1,2.112-23.04c.7-4.416.192-6.208-2.176-7.936-.64-.448-1.088-.384-1.664.576C11.52-30.336,3.136-15.168,0-6.528-1.28-3.072-.768-.576.32.64c.448.512.9.384,1.088-.256C3.968-7.3,10.5-19.2,15.3-27.456ZM42.688-33.6c-5.376,8.32-11.776,20.224-14.72,28.1-.64,1.728-.64,2.56-.064,3.648A13.573,13.573,0,0,0,29.248.512c.768.96,1.472.96,2.688.64C35.52.192,42.5-1.472,46.08-1.408c.768,0,.832-.384.64-.96-.7-1.92-2.3-2.944-5.44-2.816A46.9,46.9,0,0,0,31.36-3.2c1.344-3.008,3.072-6.528,4.928-10.112A55.3,55.3,0,0,1,48.128-15.1c.832,0,.832-.384.64-.96-.64-1.984-2.048-3.008-5.248-2.88a36.384,36.384,0,0,0-4.544.512c3.136-5.7,6.272-11.264,8.832-15.1,3.9-.64,8.384-1.792,12.992-1.728.768.128.9-.32.7-.832-.768-2.112-2.176-3.2-4.864-3.136-3.584.064-10.624,1.92-15.936,1.6-.64-.064-.832.192-.7.768A4.553,4.553,0,0,0,42.688-33.6Zm27.52,8.832c-.576-3.84-1.088-7.1-1.6-8.96-1.216-4.224-3.328-5.44-4.928-5.7-.64-.128-.96.256-.832.9,1.408,5.568,2.3,11.9,3.2,18.048C60.416-14.528,55.424-8.96,53.7-6.208,51.712-3.136,51.712-.9,52.288.512c.192.512.64.64,1.024.128A149.39,149.39,0,0,1,66.944-15.04c.448,2.688.96,5.312,1.536,7.808,1.536,6.336,4.1,8,6.592,8.192.7.064,1.024-.448.576-1.152C73.408-4.032,72-11.9,70.976-19.2c4.16-4.16,8.128-7.936,11.072-10.752,3.968-3.776,4.608-7.04,4.224-8.832-.192-.832-.7-1.152-1.472-.448C81.344-36.032,75.776-30.464,70.208-24.768ZM98.048-33.6C92.1-24.576,85.184-10.688,83.712-5.44c-.832,3.072-.064,4.992.832,5.824.448.448.768.448,1.024-.192C90.56-11.52,96-20.48,99.84-27.456c1.728-3.136,2.176-5.248,2.112-6.784,3.712-.64,7.744-1.28,10.88-.96.832.064.96-.448.768-.96-.96-2.5-3.392-3.2-6.08-3.264-3.648-.128-14.272,2.24-19.968,1.792-.64-.064-.9.256-.7.832.7,2.368,3.456,3.776,7.3,3.648A33.256,33.256,0,0,0,98.048-33.6Zm20.1,25.024c-.576.192-.832.64-.128,1.472,9.024,10.88,20.16,9.664,24,5.248,2.816-3.264,3.136-6.208.7-7.936-3.584-2.56-11.776-5.952-11.584-10.112.32-8,16.064-17.792,18.24-15.552,1.536,1.6-3.264,6.912-4.608,9.984-1.344,3.008-.576,4.992.64,6.208.7.7,1.088.384,1.408-.192a73.709,73.709,0,0,1,4.416-7.1c.96-1.344,2.5-3.84,1.856-6.4a11.511,11.511,0,0,0-3.2-5.376c-2.112-1.92-5.184-1.408-8.256-.128-5.7,2.432-15.616,9.92-15.616,18.688,0,6.592,10.112,10.56,13.5,13.44a2.215,2.215,0,0,1,.128,3.328,6.108,6.108,0,0,1-3.968,1.152c-4.16,0-8.512-3.328-11.072-5.376A7.365,7.365,0,0,0,118.144-8.576ZM165.7-33.6c-5.952,9.024-12.864,22.912-14.336,28.16-.832,3.072-.064,4.992.832,5.824.448.448.768.448,1.024-.192,4.992-11.712,10.432-20.672,14.272-27.648,1.728-3.136,2.176-5.248,2.112-6.784,3.712-.64,7.744-1.28,10.88-.96.832.064.96-.448.768-.96-.96-2.5-3.392-3.2-6.08-3.264-3.648-.128-14.272,2.24-19.968,1.792-.64-.064-.9.256-.7.832.7,2.368,3.456,3.776,7.3,3.648A33.256,33.256,0,0,0,165.7-33.6Zm34.112-4.608c-1.792-1.856-4.992-2.56-8.7-1.28-7.232,2.56-19.2,14.4-19.2,28.032,0,5.248,2.048,10.048,7.3,11.968,8.7,3.2,16.768-4.288,21.952-13.824C205.952-22.144,207.744-34.752,199.808-38.208ZM196.48-15.1C191.1-5.248,183.552-.128,179.328-1.92c-4.352-1.856-4.224-12.672,1.92-22.208,6.016-9.344,14.144-13.7,17.28-12.544C202.048-35.392,202.3-25.792,196.48-15.1Zm12.928,2.624A167.093,167.093,0,0,1,219.968.768c.384.576.7.384,1.024-.128.832-1.28.576-3.456-.32-5.184a53.248,53.248,0,0,0-6.08-8.768c7.1-1.664,14.016-5.7,17.472-10.3a11.638,11.638,0,0,0,1.984-11.008c-1.536-4.352-4.352-5.312-7.616-5.184-4.288.192-9.088,2.816-14.464,3.456-.832.128-1.024.448-.7,1.088a4.681,4.681,0,0,0,4.1,2.56c-5.632,8.832-11.648,20.992-13.248,26.816-.96,3.456-.32,5.376.576,6.336.448.448.768.384,1.024-.256C205.824-5.056,207.68-9.088,209.408-12.48Zm9.856-20.608c4.224-1.152,10.624-4.48,12.032-.9,1.856,4.544-5.376,13.888-19.52,17.024,1.728-3.136,3.328-5.824,5.056-8.9C218.56-29.056,219.264-31.3,219.264-33.088Zm21.7,20.48c7.872-8.512,13.376-13.376,17.984-17.856,3.776-3.712,4.416-6.528,3.9-8.384-.192-.7-.64-.9-1.344-.32-5.056,4.48-14.08,13.312-20.032,19.9.256-4.8.768-8.96.96-12.544.256-4.608-.7-6.464-2.24-7.424-.576-.384-1.152-.32-1.344.7-1.216,6.08-1.728,15.872-1.856,23.68a67.425,67.425,0,0,0-3.968,9.28c-.96,3.328-.32,5.568.64,6.4.512.448.96.448,1.216-.192A85.944,85.944,0,0,1,240.96-12.608Z" transform="translate(0.754 40.139)"/></svg>
                    <p>次の記事を読む ＞</p>
                </div>
                <div className="articleView">
                    <figure>
                        <Img 
                          fluid={pageContext.previous.eyecatch.fluid}
                          alt={pageContext.previous.eyecatch.description}
                        />
                    </figure>
                    <div className="viewDetail">
                      {pageContext.previous.category.map(cat => (
                        <div id="viewCat" className={cat.categorySlug} key={cat.id}><p>{cat.category}</p></div>
                      ))}
                      <div className="viewTitle">{pageContext.previous.title}</div>
                      <time datatime={pageContext.previous.publishDate}>
                          {pageContext.previous.publishDateJP}
                      </time>
                    </div>
                </div>
              </Link>
            )}
          </div>
          <div className="next">
            {pageContext.next && (
              <Link to={`/${pageContext.next.slug}/`} rel="prev">
                <div className="nextPrevTitle">
                    <svg viewBox="0 0 360.182 41.595"><path d="M13.184-32.576C7.616-23.808,1.6-11.776-.064-5.952-1.024-2.5-.384-.576.512.384.96.832,1.28.832,1.536.192,3.776-5.12,5.7-9.344,7.488-12.864a5.861,5.861,0,0,0,3.968.64c8.384-1.6,15.3-6.4,18.5-11.392,2.176-3.392,3.264-7.1,1.92-10.944-1.536-4.416-4.352-5.44-7.616-5.312-4.352.192-9.152,2.88-14.464,3.456-.832.064-.96.448-.64,1.152A4.742,4.742,0,0,0,13.184-32.576ZM9.344-16.448c1.92-3.584,3.712-6.528,5.376-9.472,1.792-3.072,2.432-5.312,2.432-7.04,4.224-1.216,10.624-4.544,11.968-1.024C30.848-29.5,23.68-19.136,9.344-16.448ZM33.536-12.48A167.092,167.092,0,0,1,44.1.768c.384.576.7.384,1.024-.128.832-1.28.576-3.456-.32-5.184a53.248,53.248,0,0,0-6.08-8.768c7.1-1.664,14.016-5.7,17.472-10.3a11.638,11.638,0,0,0,1.984-11.008c-1.536-4.352-4.352-5.312-7.616-5.184-4.288.192-9.088,2.816-14.464,3.456-.832.128-1.024.448-.7,1.088a4.681,4.681,0,0,0,4.1,2.56C33.856-23.872,27.84-11.712,26.24-5.888c-.96,3.456-.32,5.376.576,6.336.448.448.768.384,1.024-.256C29.952-5.056,31.808-9.088,33.536-12.48Zm9.856-20.608c4.224-1.152,10.624-4.48,12.032-.9C57.28-29.44,50.048-20.1,35.9-16.96c1.728-3.136,3.328-5.824,5.056-8.9C42.688-29.056,43.392-31.3,43.392-33.088ZM67.264-33.6c-5.376,8.32-11.776,20.224-14.72,28.1-.64,1.728-.64,2.56-.064,3.648A13.573,13.573,0,0,0,53.824.512c.768.96,1.472.96,2.688.64,3.584-.96,10.56-2.624,14.144-2.56.768,0,.832-.384.64-.96-.7-1.92-2.3-2.944-5.44-2.816A46.9,46.9,0,0,0,55.936-3.2c1.344-3.008,3.072-6.528,4.928-10.112A55.3,55.3,0,0,1,72.7-15.1c.832,0,.832-.384.64-.96-.64-1.984-2.048-3.008-5.248-2.88a36.384,36.384,0,0,0-4.544.512c3.136-5.7,6.272-11.264,8.832-15.1,3.9-.64,8.384-1.792,12.992-1.728.768.128.9-.32.7-.832-.768-2.112-2.176-3.2-4.864-3.136-3.584.064-10.624,1.92-15.936,1.6-.64-.064-.832.192-.7.768A4.553,4.553,0,0,0,67.264-33.6Zm16,28.608c1.6-9.792,3.712-18.816,5.056-24.96,1.088-4.928.832-7.3-.64-9.024-.576-.7-1.024-.576-1.408.384-2.3,6.144-5.5,21.056-6.592,30.976-.512,4.48.512,6.784,2.88,8.576.9.64,1.344.384,1.792-.32,7.488-11.648,17.664-24.192,22.208-30.208,3.136-4.16,3.968-6.848,3.52-9.088-.192-.9-.832-1.024-1.472-.32C102.912-33.024,89.408-15.3,83.264-4.992Zm34.688-34.432c-5.184,7.488-14.208,24-17.344,32.7-1.408,3.9-.64,6.144.256,7.1.512.576.768.512,1.024-.128,4.672-10.5,11.712-22.848,15.68-29.824,2.752-4.864,2.816-7.936,1.92-9.792C119.1-40.128,118.528-40.256,117.952-39.424Zm24.9,1.216c-1.792-1.856-4.992-2.56-8.7-1.28-7.232,2.56-19.2,14.4-19.2,28.032,0,5.248,2.048,10.048,7.3,11.968,8.7,3.2,16.768-4.288,21.952-13.824C148.992-22.144,150.784-34.752,142.848-38.208ZM139.52-15.1C134.144-5.248,126.592-.128,122.368-1.92c-4.352-1.856-4.224-12.672,1.92-22.208,6.016-9.344,14.144-13.7,17.28-12.544C145.088-35.392,145.344-25.792,139.52-15.1ZM151.616.768c4.416,1.792,10.112.192,14.656-6.08,4.288-5.952,12.224-20.672,14.464-25.6,1.664-3.712,1.6-6.592.832-7.936-.448-.7-1.024-.9-1.536-.064-3.52,5.568-10.5,18.24-14.016,25.088-4.48,8.64-9.6,14.272-13.5,12.736-1.856-.7-2.048-3.136-1.28-6.4,1.6-6.784,8.064-16.32,11.2-22.4,2.5-4.8,2.24-7.3,1.216-8.9-.448-.7-1.024-.832-1.536-.064-5.824,8.832-13.056,20.864-14.848,28.1C145.536-3.712,148.48-.512,151.616.768Zm20.672-9.344c-.576.192-.832.64-.128,1.472,9.024,10.88,20.16,9.664,24,5.248,2.816-3.264,3.136-6.208.7-7.936-3.584-2.56-11.776-5.952-11.584-10.112.32-8,16.064-17.792,18.24-15.552,1.536,1.6-3.264,6.912-4.608,9.984-1.344,3.008-.576,4.992.64,6.208.7.7,1.088.384,1.408-.192a73.709,73.709,0,0,1,4.416-7.1c.96-1.344,2.5-3.84,1.856-6.4a11.511,11.511,0,0,0-3.2-5.376c-2.112-1.92-5.184-1.408-8.256-.128-5.7,2.432-15.616,9.92-15.616,18.688,0,6.592,10.112,10.56,13.5,13.44a2.215,2.215,0,0,1,.128,3.328,6.108,6.108,0,0,1-3.968,1.152c-4.16,0-8.512-3.328-11.072-5.376A7.365,7.365,0,0,0,172.288-8.576Zm42.5,0c-.576.192-.832.64-.128,1.472,9.024,10.88,20.16,9.664,24,5.248,2.816-3.264,3.136-6.208.7-7.936-3.584-2.56-11.776-5.952-11.584-10.112.32-8,16.064-17.792,18.24-15.552,1.536,1.6-3.264,6.912-4.608,9.984-1.344,3.008-.576,4.992.64,6.208.7.7,1.088.384,1.408-.192a73.709,73.709,0,0,1,4.416-7.1c.96-1.344,2.5-3.84,1.856-6.4a11.511,11.511,0,0,0-3.2-5.376c-2.112-1.92-5.184-1.408-8.256-.128-5.7,2.432-15.616,9.92-15.616,18.688,0,6.592,10.112,10.56,13.5,13.44a2.215,2.215,0,0,1,.128,3.328,6.108,6.108,0,0,1-3.968,1.152c-4.16,0-8.512-3.328-11.072-5.376A7.365,7.365,0,0,0,214.784-8.576ZM262.336-33.6C256.384-24.576,249.472-10.688,248-5.44c-.832,3.072-.064,4.992.832,5.824.448.448.768.448,1.024-.192,4.992-11.712,10.432-20.672,14.272-27.648,1.728-3.136,2.176-5.248,2.112-6.784,3.712-.64,7.744-1.28,10.88-.96.832.064.96-.448.768-.96-.96-2.5-3.392-3.2-6.08-3.264-3.648-.128-14.272,2.24-19.968,1.792-.64-.064-.9.256-.7.832.7,2.368,3.456,3.776,7.3,3.648A33.256,33.256,0,0,0,262.336-33.6Zm34.112-4.608c-1.792-1.856-4.992-2.56-8.7-1.28-7.232,2.56-19.2,14.4-19.2,28.032,0,5.248,2.048,10.048,7.3,11.968,8.7,3.2,16.768-4.288,21.952-13.824C302.592-22.144,304.384-34.752,296.448-38.208ZM293.12-15.1C287.744-5.248,280.192-.128,275.968-1.92c-4.352-1.856-4.224-12.672,1.92-22.208,6.016-9.344,14.144-13.7,17.28-12.544C298.688-35.392,298.944-25.792,293.12-15.1Zm12.928,2.624A167.093,167.093,0,0,1,316.608.768c.384.576.7.384,1.024-.128.832-1.28.576-3.456-.32-5.184a53.246,53.246,0,0,0-6.08-8.768c7.1-1.664,14.016-5.7,17.472-10.3a11.638,11.638,0,0,0,1.984-11.008c-1.536-4.352-4.352-5.312-7.616-5.184-4.288.192-9.088,2.816-14.464,3.456-.832.128-1.024.448-.7,1.088A4.681,4.681,0,0,0,312-32.7c-5.632,8.832-11.648,20.992-13.248,26.816-.96,3.456-.32,5.376.576,6.336.448.448.768.384,1.024-.256C302.464-5.056,304.32-9.088,306.048-12.48ZM315.9-33.088c4.224-1.152,10.624-4.48,12.032-.9,1.856,4.544-5.376,13.888-19.52,17.024,1.728-3.136,3.328-5.824,5.056-8.9C315.2-29.056,315.9-31.3,315.9-33.088Zm21.7,20.48c7.872-8.512,13.376-13.376,17.984-17.856,3.776-3.712,4.416-6.528,3.9-8.384-.192-.7-.64-.9-1.344-.32-5.056,4.48-14.08,13.312-20.032,19.9.256-4.8.768-8.96.96-12.544.256-4.608-.7-6.464-2.24-7.424-.576-.384-1.152-.32-1.344.7-1.216,6.08-1.728,15.872-1.856,23.68a67.421,67.421,0,0,0-3.968,9.28c-.96,3.328-.32,5.568.64,6.4.512.448.96.448,1.216-.192A85.946,85.946,0,0,1,337.6-12.608Z" transform="translate(0.541 40.139)"/></svg>
                    <p>＜ 前の記事を読む</p>
                </div>
                <div className="articleView">
                    <figure>
                        <Img 
                            fluid={pageContext.next.eyecatch.fluid}
                            alt={pageContext.next.eyecatch.description}
                        />
                    </figure>
                    <div className="viewDetail">
                      {pageContext.next.category.map(cat => (
                          <div id="viewCat" className={cat.categorySlug} key={cat.id}><p>{cat.category}</p></div>
                        ))}
                      <div className="viewTitle">{pageContext.next.title}</div>
                      <time datatime={pageContext.next.publishDate}>
                          {pageContext.next.publishDateJP}
                      </time>
                    </div>
                </div>
              </Link>
            )}
          </div>
        </div>
        <div className="newPosts">関連記事</div>
        <Relatedjirei id={pageContext.id} />
        <Relatedsogyomae id={pageContext.id} />
        <Relatedshikin id={pageContext.id} />
        <div className="breadCrumb">
          <ol>
            <li>
              <Link to={`/`}>TOP</Link>
            </li>
            <li>
              {data.contentfulBlogPost.category.map(cat => (  <Link to={`/${cat.categorySlug}/`} key={cat.id}>{cat.category}</Link>))}
            </li>
            <li>
              {data.contentfulBlogPost.title}        
            </li>
          </ol>
        </div>
      </div>
      <Sidebar />
    </main>
  </Layout>
  )}

export const query = graphql`
  query($id: String!) {
        contentfulBlogPost(id: { eq: $id }) {
            title
            publishDateJP:publishDate(formatString: "YYYY/MM/DD")
            publishDate
            category {
              category
              categorySlug
              id
            }
            content {
                json
            }
            tags {
              id
              tagTitle
              tagSlug
            }
            eyecatch {
              fluid(maxWidth: 1600) {
                ...GatsbyContentfulFluid_withWebp
              }
              description
              file {
                details {
                  image {
                    height
                    width
                  }
                }
                url
              }
            }
        }
  }
`
